/**
 * @fileoverview GET handler for the "/engagement/api/suppression_lists/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementApiSuppressionListsId } from "./constants";
import type { EngagementApiSuppressionListsIdResult } from "./types";
import { isEngagementApiSuppressionListsIdResult } from "./validators";

export const getEngagementApiSuppressionListsId = reactQueryFetcherAdapter(
  engagementApiSuppressionListsId,
  (
    signal: AbortSignal,
    id: string,
    app_group_id: string,
    for_editing: boolean,
    only_get_contained_filter: boolean
  ): Promise<EngagementApiSuppressionListsIdResult> => {
    return fetch(
      `/engagement/api/suppression_lists/${id}`,
      "GET",
      { id, app_group_id, for_editing, only_get_contained_filter },
      { signal }
    );
  },
  isEngagementApiSuppressionListsIdResult
);
